/* eslint-disable react-hooks/exhaustive-deps */
import {useMemo, useState} from "react"
import {AppliedFilter, FilterKey, FilterList, formatDateFilterValue} from "types/filter"
import {CallLogStats, StudentCallLogFilter, StudentCallLogListView} from "./parts"
import moment from "moment"

type Props = {
    departmentId: number
    filterKey: FilterKey
    studentProfileId?: number
}

const INITIAL_FILTER: AppliedFilter = {
    search: "",
    filters: {}
}

export function CallLog(props: Props) {
    const {departmentId, filterKey, studentProfileId} = props
    const [appliedFilter, setAppliedFilter] = useState<AppliedFilter>()

    const onApplyFilter = (payload: AppliedFilter) => {
        setAppliedFilter(payload)
    }

    const filterParams = useMemo(() => {
        const {staffs, status, direction, students, program, campus, createdAtRange, admAdvisors} =
            appliedFilter?.filters ?? {}

        let filter: FilterList = {}

        if (staffs) {
            filter.staffUserIds = {
                operator: staffs.operator,
                value: staffs.value.map(({userId}) => userId)
            }
        }
        if (students) {
            filter.studentUserIds = {
                operator: students.operator,
                value: students.value.map(({id}) => id)
            }
        }
        if (program) {
            filter.programIds = {
                operator: program.operator,
                value: program.value.map(({id}) => id)
            }
        }
        if (campus) {
            filter.campusIds = {
                operator: campus.operator,
                value: campus.value.map(({id}) => id)
            }
        }
        if (status) {
            filter.status = {
                operator: status.operator,
                value: status.value.map(({id}) => id)
            }
        }
        if (createdAtRange) {
            filter.createdAtRange = {
                operator: createdAtRange.operator,
                value: formatDateFilterValue(createdAtRange.operator, createdAtRange.value)
            }
        }
        if (admAdvisors) {
            filter.admAdvisorProfileIds = {
                operator: admAdvisors.operator,
                value: admAdvisors.value.map((profile) => profile.profileId)
            }
        }
        if (direction) {
            filter.direction = {
                operator: direction.operator,
                value: direction.value.id
            }
        }

        return {
            filters: filter,
            search: appliedFilter?.search,
            studentProfileId: studentProfileId
        }
    }, [appliedFilter])

    return (
        <div>
            <StudentCallLogFilter
                filterKey={filterKey}
                initialFilter={INITIAL_FILTER}
                onApplyFilter={onApplyFilter}
                onClearFilter={() => onApplyFilter({filters: {}, search: ""})}
                departmentId={departmentId}
            />
            {!studentProfileId && <CallLogStats departmentId={departmentId} filterParams={filterParams} />}
            <StudentCallLogListView
                filterKey={filterKey}
                filterParams={filterParams}
                departmentId={departmentId}
                studentProfileId={studentProfileId}
            />
        </div>
    )
}
